export const es = {
  // Navigation
  home: "Inicio",
  cart: "Carrito",
  checkout: "Pagar",
  profile: "Perfil",
  search: "Buscar",
  
  // Product listing
  addToCart: "Añadir al Carrito",
  updateCart: "Actualizar Carrito",
  buyNow: "Comprar Ahora",
  price: "Precio",
  allProducts: "Todos los Productos",
  featuredItems: "Destacados",
  specialOffers: "Ofertas Especiales",
  categories: "Categorías",
  allCategories: "Todo categorías",
  viewAll: "Ver Todo",
  youMightAlsoLike: "También te puede gustar",
  reviews: "reseñas",
  exploreServices: "Explorar Servicios",
  viewOffer: "Ver Oferta",
  details: "Detalles",
  products: "Productos y Servicios",
  item: "artículo",
  items: "artículos",
  
  // Search
  searchForProducts: "Buscar productos o servicios",
  recentSearches: "Búsquedas Recientes",
  noProductsFound: "No se encontraron productos",
  
  // Cart
  yourCart: "Tu Carrito",
  emptyCart: "Tu carrito está vacío",
  continueShopping: "Continuar Comprando",
  removeItem: "Eliminar",
  quantity: "Cantidad",
  total: "Total",
  subtotal: "Costos de servicio",
  proceedToCheckout: "Pagar",
  browseServices: "Explora nuestros servicios",
  
  // Checkout
  paymentDetails: "Detalles de Pago",
  cardNumber: "Número de Tarjeta",
  cardholderName: "Nombre del Titular",
  expiryDate: "Fecha de Vencimiento",
  cvv: "CVV",
  billingAddress: "Dirección de Facturación",
  placeOrder: "Realizar Pedido",
  processing: "Procesando...",
  creditCard: "Tarjeta de Crédito",
  quickCheckout: "Pago Rápido",
  payOnDeliveryDesc: "Pago en efectivo o con tarjeta cuando llegue tu pedido",
  continueWithPaypal: "Continuar con PayPal",
  connectPaypal: "Conectar PayPal",
  continueWithApplePay: "Continuar con Apple Pay",
  connectApplePay: "Conectar Apple Pay",
  orderSummary: "Resumen del Pedido",
  paymentMethod: "Método de Pago",
  cardDetails: "Detalles de la Tarjeta",
  pay: "Pagar",
  currency: "€",
  fullName: "Nombre Completo",
  email: "Correo Electrónico",
  phone: "Número de Teléfono",
  deliveryAddress: "Dirección de Entrega",
  nameRequired: "El nombre es obligatorio",
  validEmailRequired: "Se requiere un correo electrónico válido",
  phoneRequired: "El número de teléfono es obligatorio",
  addressRequired: "La dirección de entrega es obligatoria",
  completeYourOrder: "Completa tu pedido rápidamente con pago con tarjeta",
  payWithCard: "Pagar con tarjeta",
  
  // Confirmation
  orderConfirmed: "¡Pedido Confirmado!",
  thankYou: "Gracias por tu pedido",
  orderNumber: "Número de Pedido",
  summaryTitle: "Resumen del Pedido",
  backToShopping: "Volver a Comprar",
  backToHome: "Volver al Inicio",
  
  // Errors
  pageNotFound: "Página No Encontrada",
  returnHome: "Volver al Inicio",
  
  // Language
  language: "Idioma",
  english: "Inglés",
  spanish: "Español",
  italian: "Italiano",
  
  // Hotel
  welcomeMessage: "Bienvenido a",
  
  // Misc
  loading: "Cargando...",
  error: "Ocurrió un error",
  retry: "Reintentar",
  close: "Cerrar",


  noProductsAvailable: "Nessun prodotto disponibile",
  noProductsInCategory: "Nessun prodotto in questa categoria",
};